import { changeCustomerSelectCustomerContainerStyles } from "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerSelectCustomerContainer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

changeCustomerSelectCustomerContainerStyles.cancelButton = {
    css: css`
        margin-right: 15px;
        border-radius: 0px;
        padding: 10px 34px;
        background: ${getColor("common.background")};
        border: 2px solid ${getColor("primary")};
        span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
        &:hover {
            opacity: 0.3;
            background: none !important;
        }
    `,
};

changeCustomerSelectCustomerContainerStyles.continueButton = {
    css: css`
        border-radius: 0px;
        padding: 10px 34px;
        border: 2px solid ${getColor("primary")};
        background: ${getColor("primary")};
        span[class^="TypographyStyle"] {
            color: ${getColor("primary.contrast")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
        &:hover {
            background: ${getColor("text.accent")};
            /* border: 2px solid  background: ${getColor("text.accent")}; */
            span[class^="TypographyStyle"] {
                color: ${getColor("primary.contrast")};
            }
        }
        &:disabled:hover {
            background-color: rgb(204, 204, 204) !important;
        }

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                null,
                null,
                null,
            ])}
    `,
};
changeCustomerSelectCustomerContainerStyles.billToSelectorGridItem = {
    width: 12,
    css: css`
        label {
            color: ${getColor("text.main")};
        }
    `,
};
changeCustomerSelectCustomerContainerStyles.shipToSelectorGridItem = {
    width: 12,
    css: css`
        label {
            color: ${getColor("text.main")};
        }
        display:none;
    `,
};
changeCustomerSelectCustomerContainerStyles.billToSelector = {
    billToSelectorDynamicDropdown: {
        cssOverrides: {
            list: css`
                width: 100%;
                /* top: 47px !important; */
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            overflow-y: scroll;
                            max-height: 300px !important;
                            top: 46px !important;
                            -webkit-overflow-scrolling: touch;
                            &::-webkit-scrollbar {
                                -webkit-appearance: none;
                                width: 7px;
                            }

                            &::-webkit-scrollbar-thumb {
                                border-radius: 2px;
                                background-color: ${getColor("text.main")};
                                box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
                            }
                        `,
                        css`
                            overflow-y: scroll;
                            max-height: 300px !important;
                            top: 46px !important;
                            -webkit-overflow-scrolling: touch;
                            &::-webkit-scrollbar {
                                -webkit-appearance: none;
                                width: 7px;
                            }

                            &::-webkit-scrollbar-thumb {
                                border-radius: 2px;
                                background-color: ${getColor("text.main")};
                                box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
                            }
                        `,
                        css`
                            overflow-y: auto;
                            max-height: 400px !important;
                            top: 40px !important;
                        `,
                        css`
                            overflow-y: auto;
                            max-height: 400px !important;
                            top: 40px !important;
                        `,
                        css`
                            overflow-y: auto;
                            max-height: 400px !important;
                            top: 40px !important;
                        `,
                    ])}
            `,
        },
    },
};
changeCustomerSelectCustomerContainerStyles.shipToSelector = {
    shipToSelectorDynamicDropdown: {
        cssOverrides: {
            list: css`
                width: 100%;
                /* top: 47px !important; */
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            overflow-y: scroll;
                            max-height: 110px !important;
                            top: 46px !important;
                            -webkit-overflow-scrolling: touch;
                            &::-webkit-scrollbar {
                                -webkit-appearance: none;
                                width: 7px;
                            }

                            &::-webkit-scrollbar-thumb {
                                border-radius: 2px;
                                background-color: ${getColor("text.main")};
                                box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
                            }
                        `,
                        css`
                            overflow-y: scroll;
                            max-height: 110px !important;
                            top: 46px !important;
                            -webkit-overflow-scrolling: touch;
                            &::-webkit-scrollbar {
                                -webkit-appearance: none;
                                width: 7px;
                            }

                            &::-webkit-scrollbar-thumb {
                                border-radius: 2px;
                                background-color: ${getColor("text.main")};
                                box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
                            }
                        `,
                        css`
                            overflow-y: auto;
                            max-height: 400px !important;
                            top: 40px !important;
                        `,
                        css`
                            overflow-y: auto;
                            max-height: 400px !important;
                            top: 40px !important;
                        `,
                        css`
                            overflow-y: auto;
                            max-height: 400px !important;
                            top: 40px !important;
                        `,
                    ])}
            `,
        },
    },
};